export default __webpack_public_path__ + "static/media/home-component-markdown.940b8131.md";